<template>
   <v-container fluid style="margin-top: -12px;"> 

       <v-row style="width:100%; margin: -12px 0;">
      <v-data-table :loading="isLoading" :disableFiltering="true"
            :headers="headers" :class="tableConfig.onRowSelect?'row-pointer':''"
						ref = "dataTable"
						:loading-text="$t('wkt.admin.common.table.loading')"
						:no-data-text="$t('wkt.admin.common.table.no_data')"
						:no-results-text="$t('wkt.admin.common.table.no_results')"
            :options.sync="options" 
						:server-items-length="20"
            :items="data" 
						:disablePagination="true" 
						hide-default-footer
            :fixedHeader="true" 
						:height="tableHeight" 
						style="max-height: 400px; width: 100%;"
            @click:row="onRowSelected"
        >
        
        <!-- formateadores dinámicos 
        <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" v-slot:[`item.${header.value}`]="{ header, value }">
            {{ _self[header.formatter](value, header) }}
        </template>
        -->

            <template v-slot:[`item.avatar`]="{ item }">
               <v-img max-width="38" max-height="38" :src="getProfileAssetUrl(item.avatar_url)" style="float:left; margin: 5px;"></v-img>
               <div style=" margin: 5px;">
                <span v-if="item.avatar_title" class="truncate" style="display: block; white-space:nowrap;">{{item.avatar_title}}</span>
                <span v-if="item.avatar_subtitle" style="display: block; white-space:nowrap; color: grey;">{{item.avatar_subtitle}}</span>
                </div>
            </template>

            <template v-slot:[`item.composite1`]="{ item }">
               <v-img v-if="item.composite1_url" max-width="38" max-height="38" :src="getProfileAssetUrl(item.composite1_url)" style="float:left; margin: 5px;"></v-img>
               <div style=" margin: 5px;">
                <span v-if="item.composite1_title" class="truncate" :style="'display: block; white-space:nowrap; color: '+(item.composite1_title_color?item.composite1_title_color:'unset')+';'">{{st(item.composite1_title)}}</span>
                <span v-if="item.composite1_subtitle"  :style="'display: block; white-space:nowrap; color: '+(item.composite1_subtitle_color?item.composite1_subtitle_color:'grey')+';'">{{st(item.composite1_subtitle)}}</span>
                </div>
            </template>

            <template v-slot:[`item.composite2`]="{ item }">
               <v-img v-if="item.composite2_url" max-width="38" max-height="38" :src="getProfileAssetUrl(item.composite2_url)" style="float:left; margin: 5px;"></v-img>
               <div style=" margin: 5px;">
                <span v-if="item.composite2_title" class="truncate" :style="'display: block; white-space:nowrap; color: '+(item.composite2_title_color?item.composite2_title_color:'unset')+';'">{{st(item.composite2_title)}}</span>
                <span v-if="item.composite2_subtitle"  :style="'display: block; white-space:nowrap; color: '+(item.composite2_subtitle_color?item.composite2_subtitle_color:'grey')+';'">{{st(item.composite2_subtitle)}}</span>
                </div>
            </template>

            <template v-slot:[`item.composite3`]="{ item }">
               <v-img v-if="item.composite3_url" max-width="38" max-height="38" :src="getProfileAssetUrl(item.composite3_url)" style="float:left; margin: 5px;"></v-img>
               <div style=" margin: 5px;">
                <span v-if="item.composite3_title" class="truncate" :style="'display: block; white-space:nowrap; color: '+(item.composite3_title_color?item.composite3_title_color:'unset')+';'">{{st(item.composite3_title)}}</span>
                <span v-if="item.composite3_subtitle" :style="'display: block; white-space:nowrap; color: '+(item.composite3_subtitle_color?item.composite3_subtitle_color:'grey')+';'">{{st(item.composite3_subtitle)}}</span>
                </div>
            </template>

        </v-data-table>
     </v-row>

    </v-container>
</template>

<script> 
import BaseModule from '../../common/BaseModule.js'
import CommonFormatter from '../../common/CommonFormatter.js'
import api from '../../../api/worktime'
import { EventBus }  from './../../util/event-bus'

export default {
  name: 'TableWidget',
  mixins: [BaseModule, CommonFormatter],
  components: { 

  },
   props: ['config','context'],
  
  data() {
      return {
        isLoading: true,
        options: {},
        headers: [],
        data: [],
        tableConfig: {},
        tableHeight:200
      }
  },mounted() {
    },
    watch: {
      options: {
        handler () { 
            this.loadData();
        },
        deep: true,
      },
      context: function() { 
        this.update();
      }
    },
   methods: {
    onRowSelected(item) {
        if (!this.tableConfig.onRowSelect) {
            return;
        }
        EventBus.$emit('widget-data-click',{ mode:this.tableConfig.onRowSelect.mode,type:this.tableConfig.onRowSelect.type,action:this.tableConfig.onRowSelect.action, payload:item[this.tableConfig.onRowSelect.payload], eventConfig:this.tableConfig.onRowSelect});
    },
    loadData() {
        if (!this.config && !this.config.fields) {
            return;
        }
        const me = this;
        me.isLoading=true;
        this.tableConfig = JSON.parse(me.config.fields);
        const fields = this.tableConfig.headers?this.tableConfig.headers:this.tableConfig;
        me.headers = [];

        for(var k in fields) {
                let item = fields[k];
                item['value'] = item['field'];
                item['text'] = this.st(item['label']);
                item['desc'] = this.st(item['desc']);
                item['label'] = this.st(item['label']);

                me.headers.push(item);
            }

        const { sortBy, sortDesc } = this.options; 

        let queryContext = {
            'sortBy':sortBy.length>0?this.translateSortBy(sortBy[0]):null,
            'sortDesc':sortDesc.length>0?sortDesc[0]:null,
            workplaceIds: this.context.workplaceIds,
            departmentIds: this.context.departmentIds
        };

        api.getWidgetData(this.config.id, queryContext, (res) => {
            me.isLoading=false;
            me.addCustomData(me, res);
            me.data = me.formatData(me,res);
            me.fixLayout(me);
        }, err => {
            console.log(err); //TODO: mostrar toast?
            this.isLoading=false;
        })
    },
    translateSortBy(field) {
        if (field=='avatar'){
            return 'avatar_title';
        } 
        if (field=='composite1'){
            return 'composite1_title';
        } 
        if (field=='composite2'){
            return 'composite2_title';
        } 
        if (field=='composite3'){
            return 'composite3_title';
        } 
        return field;
    },
    exportData() {
        this.$refs.exportXlsx.$el.click();
    },
    designQuery() {
        this.$emit('design')
    },
    update() {
        this.loadData(this);
    },
    fixLayout(vm) {
        this.$nextTick(() => {
            vm.tableHeight = window.getComputedStyle(vm.$refs.dataTable.$el, null).getPropertyValue("max-height");
        });
    },
   }
};
</script>
 